
import React from 'react';
import { TableCell } from '@/components/ui/table';
import { Attendee } from '@/types/attendee';

interface ClassCellProps {
  attendee: Attendee;
  isMobile: boolean;
}

export const ClassCell: React.FC<ClassCellProps> = ({ attendee, isMobile }) => {
  return (
    <TableCell className={isMobile ? 'max-w-[80px] truncate pl-2 pr-1 py-2' : ''} title={attendee.class}>
      {attendee.class}
    </TableCell>
  );
};
